import type { ParsResponse } from './parsResponse';
import type { ParsStatus } from './parsStatus';
import type { Review } from './review';

export interface Credit {
  id: string;
  status: 'claimed' | 'reviewed' | 'to-review';
  type: CreditType;
  searchDate: string;
  value: number;
  searchTerm: string;
  articleTitles: string[];
  review: Review[];
  updatedAt: string;
  reportingYear?: string;
  originIds?: string[];
  externalIds?: string[];
  titles?: string[];
  parsStatus?: ParsStatus;
  startDate?: string;
  endDate?: string;
  claimDate?: string | null;
  articleXid?: string[];
  submittedBoards?: [];
  rating?: {};
  answered?: number;
  counted?: number;
  countedIds?: string[];
  remaining?: number;
  creditsCount?: number;
  questionIds?: number;
  parsResponse?: ParsResponse;
  association?: CreditAssociation;
}

export enum CreditType {
  IPC = 'ipc',
  ABIM = 'abim',
  ABP = 'abp',
  ABFM = 'abfm',
  CCCR = 'cccr',
  E2I = 'e2i',
}

export enum CreditAssociation {
  AMA = 'ama',
  AHPRA = 'ahpra',
}
